<a appDisableClickEvent (click)="onCategoryClick()" [routerLink]="['/c', category.slug]" class="sub-category-card">
  <ng-container *ngIf="isMobile; else tabletAndDesktop">
    <ng-container *ngTemplateOutlet="imageContainer"></ng-container>
    <div class="sub-category-card__text-container">
      <h5 [lang]="market" title="{{ category.name }}">{{ category.name }}</h5>
    </div>
  </ng-container>
</a>

<!-- rerendering image with title so it reloads the correct size -->
<ng-template #tabletAndDesktop>
  <ng-container *ngTemplateOutlet="imageContainer"></ng-container>
  <div class="sub-category-card__text-container">
    <h4 *ngIf="!isMobile" [lang]="market" title="{{category.name}}">{{ category.name }}</h4>
  </div>
</ng-template>

<ng-template #imageContainer>
  <div class="sub-category-card__image-container">
    <img
      [appDefaultImage]="defaultCategoryImage"
      [alt]="category.name"
      [appLazyLoadImage]="getSource(category?.id)"
      [srcSet]="getSourceSet(category?.id)"
    />
  </div>
</ng-template>
